<div class="wccard p-3 mb-1">
    <app-talent-insights-ai  [requestaidata]="schoolsdataAI" [insightstabname]="'education'" [totalcount]="totalResultCount"></app-talent-insights-ai>
</div>
<div class="wccard p-3 mb-3">
    <p class="f-16 mb-2 font-weight-600">Which schools are producing this talent ?</p>

    <div>
        <div class="loader text-center" *ngIf="!school.data?.length">
            <img *ngIf="showSchoolLoader===true" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            <span *ngIf="showSchoolLoader===false">No Data Available</span>
        </div>
        <table mat-table *ngIf="school.data?.length" [dataSource]="school" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" matSort #educationTbSort="matSort" (matSortChange)="manualSort()">

            <!-- key -->
            <ng-container matColumnDef="key">
                <th mat-header-cell mat-header-cell *matHeaderCellDef  class="col-4">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['Schools']}}</p>
                </th>
                <td class="col-4 text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                    {{element.key | titlecase}}
                </td>
            </ng-container>

             <!-- doc_count -->
             <ng-container matColumnDef="doc_count">
                <th class="col-2 text-center" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['TalentCount']}}</p>
                </th>
                <td class="col-2 text-484b59 font-weight-600" mat-cell *matCellDef="let element">
                    <span class="pointer" (click)="handelRedirection('school', element.key)">{{element.doc_count | number}}</span>
                </td>
            </ng-container>

            <!-- recentGraduate -->
            <ng-container matColumnDef="recentGraduate">
                <th class="col-2 text-center" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['RecentGraduate']}}</p>
                </th>
                <td class="col-2 text-484b59 font-weight-600" mat-cell *matCellDef="let element" class="">
                    <div *ngIf="!isRecentGraduateData" class="spinner-border position-absolute text-black" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                      <p class="font-weight-600">
                        <span class="pointer" (click)="handelRedirection('recentgraduatesonly', element.key)">{{element.recentGraduate | number}}</span>
                      </p>
                </td>
            </ng-container>

            <!-- graph -->
            <ng-container matColumnDef="graph">
                <th class="text-center col-2" mat-header-cell *matHeaderCellDef mat-sort-header="graph"
                    sortActionDescription="Sort by percentage">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['%OfTotal']}}</p>
                </th>
                <td class="col-2" mat-cell *matCellDef="let element">
                    <div class="progress d-flex align-items-center" style="height: 12px!important;">
                        <span class="mr-1 text-484b59">
                            {{getSchoolTotalPercentage(element.doc_count)}}%
                        </span>
                        <span class="progress-bar" role="progressbar" style="background-color: #2E93A1 !important;" [ngStyle]="{'width.%': getSchoolTotalPercentage(element.doc_count)}" aria-valuenow="getSchoolTotalPercentage(element.doc_count)" aria-valuemin="0" aria-valuemax="100"></span>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </div>

    <div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 10">
        <ngb-pagination [collectionSize]="totalCount <=50 ? totalCount : 50" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false" [boundaryLinks]="false" [directionLinks]="false">

        </ngb-pagination>
    </div>
</div>

<div class="wccard p-3 mb-3">
    <p class="f-16 font-weight-600 mb-6" *ngIf="education?.data?.length">
        What are the qualifications for this talent?
    </p>
    <div class="text-center">
        <div class="loader text-center" *ngIf="!education?.data?.length">
            <img *ngIf="showEducationLoader===true" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            <span *ngIf="showEducationLoader===false">No Data Available</span>
        </div>
        <div class="col wccard"  *ngIf="education?.data?.length">
            <fusioncharts width="100%" height="450" type="column2d" [dataSource]="education">
            </fusioncharts>
        </div>
    </div>
</div>

<div class="wccard p-3 mb-3">
    <p class="f-16 font-weight-600 mb-6" *ngIf="fieldOfStudy?.data?.length">
        What are the fields of study for this talent?
    </p>
    <div class="row">
        <div class="col">
            <div class="loader text-center" *ngIf="!fieldOfStudy?.data?.length">
                <img *ngIf="showFieldOfStudyLoader===true" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                <span *ngIf="showFieldOfStudyLoader===false">No Data Available</span>

            </div>
            <fusioncharts width="100%" height="450" type="bar2d" [dataSource]="fieldOfStudy" *ngIf="fieldOfStudy?.data?.length">
            </fusioncharts>

            <!-- <div class="row">
                <div class="col">
                    <fusioncharts width="90%" height="450" type="doughnut2d" [dataSource]="fieldOfStudy" *ngIf="fieldOfStudy?.data?.length">
                    </fusioncharts>
                </div>

                <div class="col">
                    <table>
                       <thead>
                            <tr>
                                <td><span class="legendaheading">Field Of Study</span></td>
                                <td><span class="legendaheading">Talent Count</span></td>
                            </tr>
                       </thead>
                       <tbody>
                            <tr *ngFor="let item of fieldOfStudy.data" class="borderBottom">
                                <td><div class="d-flex align-items-center"><div class="lagendaCircle" [ngStyle]="{backgroundColor: item.color}"></div><span class="legendaItem">{{ item.label }}</span></div></td>
                                <td><span class="legendaItem">{{ item.value }}</span></td>
                            </tr>
                       </tbody>

                      </table>
                </div>
            </div> -->
        </div>
    </div>
</div>
